import { createApiClient } from 'Network/ApiClient';

export const ActivityNotAllowedAxiosInstance = createApiClient('Activity/');


